const INDEX_ITEMS = [
  { title: '热门电影', desc: '国内外院线大片一网打尽', icon: 'ri-movie-2-line', tag: '热播' },
  { title: '经典剧集', desc: '高分好剧随时随地追', icon: 'ri-tv-2-line', tag: '精选' },
  { title: '动作大片', desc: '肾上腺素飙升的视觉盛宴', icon: 'ri-flashlight-line', tag: '劲爆' },
  { title: '爱情剧场', desc: '浪漫故事温暖你的时光', icon: 'ri-heart-line', tag: '温情' },
  { title: '悬疑推理', desc: '烧脑剧情挑战你的智商', icon: 'ri-search-eye-line', tag: '烧脑' },
  { title: '喜剧合集', desc: '欢乐笑料放松一整天', icon: 'ri-emotion-laugh-line', tag: '轻松' },
  { title: '动漫精选', desc: '热门番剧同步追更', icon: 'ri-rocket-line', tag: '追番' },
];

export default function SectionIndex() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50">专题合集</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-400 max-w-xl mx-auto">
            精选七大影视专题，满足您的每一种观影口味
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4">
          {INDEX_ITEMS.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="group flex flex-col items-center p-4 md:p-5 rounded-xl bg-background-200/70 border border-background-300/30 hover:border-primary-500/40 hover:bg-background-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/10 text-primary-400 group-hover:bg-primary-500/20 transition-colors mb-3">
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-100 whitespace-nowrap">{item.title}</h3>
              <p className="text-xs text-foreground-500 mt-1 text-center leading-snug">{item.desc}</p>
              <span className="mt-2 px-2 py-0.5 text-[10px] font-medium rounded-full bg-accent-500/15 text-accent-400 whitespace-nowrap">
                {item.tag}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}